import { render, staticRenderFns } from "./Skills.vue?vue&type=template&id=f519fd8a&scoped=true&"
import script from "./Skills.vue?vue&type=script&lang=js&"
export * from "./Skills.vue?vue&type=script&lang=js&"
import style0 from "./Skills.vue?vue&type=style&index=0&id=f519fd8a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f519fd8a",
  null
  
)

export default component.exports